import {useTranslation} from "react-i18next";
import 'moment-timezone';
import Moment from "moment/moment";
import {Link} from "react-router-dom";
// -
import OrderByHeaders from "components/ordering/OrderByHeaders";
import {useEffect} from "react";

const ContainersListTable = ({itemsShown, orderingRef}) => {
    const {t: _Tc} = useTranslation("choices");
    const {t: _Tt} = useTranslation("tags");


    const stickyHeaderStyle = {
        position: "sticky",
        top: "116px",
        backgroundColor: "white",
    };

    const headersTable = [
        {name: _Tt("container.uid"), attr: 0, direction: "asc", active: false},
        {name: _Tt("device.uuid"), attr: 1, direction: "asc", active: false},
        {name: _Tt("container.download_type"), attr: 2, direction: "asc", active: false},
        {name: _Tt("container.waste_type"), attr: 3, direction: "asc", active: false},
        {name: _Tt("common.group"), attr: 4, direction: "asc", active: false},
        {name: _Tt("common.zone"), attr: 5, direction: "asc", active: false},
        {name: _Tt("common.route"), attr: 6, direction: "asc", active: false},
        {name: _Tt("common.island"), attr: 7, direction: "asc", active: false},
        {name: _Tt("common.lastMeasure"), attr: 8, direction: "asc", active: false},
        {name: _Tt("common.filling"), attr: 9, direction: "asc", active: false},
    ]

    useEffect(() => {
        if (orderingRef && orderingRef.current && orderingRef.current.headers.length === 0) {
            orderingRef.current.setHeaders(headersTable)
        }
    }, [])

    return (
        <>
            <div className="col-12">
                <hr className="mb-4"/>
                {!itemsShown || itemsShown.length === 0 ? (
                    <div className="alert alert-secondary text-center">{_Tt("common.noData")}</div>
                ) : (
                    <table className="table table-striped">
                        <thead>
                        <tr>
                            <OrderByHeaders
                                orderingRef={orderingRef}
                                styleHeaders={stickyHeaderStyle}
                            />
                        </tr>
                        </thead>
                        <tbody>
                        {itemsShown.map((item, index) => (
                            <tr key={index} data-idx={index}>
                                <td><Link to={"/data-view/data-container/" + item.uid + "/"} className="slx-link">{item.uid}</Link></td>
                                <td>{item.uuid}</td>
                                <td>{_Tc("downloads." + item.download_type)}</td>
                                <td>{_Tc("wastes." + item.waste_type)}</td>
                                <td>{item.group_name}</td>
                                <td>{item.zone_name}</td>
                                <td>{item.route_name}</td>
                                <td>{item.island_name}</td>
                                <td>{Moment(item.measured).format("DD/MM/YYYY HH:mm:ss")}</td>
                                <td>{item.filling}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                )}
            </div>
        </>
    );
}

export default ContainersListTable;